<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Profile</h1>
        </div>
        @if(!editProfileStatus){
        <div class="content-section">
            <div class="order-view  max-WT-700 mrgn-0-auto setting-page">
                <div class="admin-profile">
                    <h4 class="mb20 text-center">View Profile</h4>
                </div>
                <div class="add-store-block input-style view-label-align">
                    <div class="form-group row align-items-baseline">
                        <div class="col-md-12" style="text-align: center">
                            <img src="{{profileData?.profilePic || 'assets/img/profile-img.jpg' }}"
                                style="height: 100px;width: 100px; border-radius: 50%" (error)="onImageError($event)" />
                        </div>
                    </div>
                    <div class="form-group row mt-3 align-items-baseline">
                        <label class="col-md-4 textalignright ">
                            <h6> Name : </h6>
                        </label>
                        <div class="col-md-8 textaligncenter">
                            <div class="form-group">
                                <p style="padding: 0px 5px!important;"> {{profileData?.firstName}}
                                    {{profileData?.lastName}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row align-items-baseline">
                        <label class="col-md-4 textalignright">
                            <h6> Email :</h6>
                        </label>
                        <div class="col-md-8 textaligncenter">
                            <div class="form-group ">
                                <p class="content-view"> {{profileData?.email}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row align-items-baseline">
                        <label class="col-md-4 textalignright">
                            <h6>Phone Number :</h6>
                        </label>
                        <div class="col-md-8 textaligncenter">
                            <div class="form-group ">
                                <p class="content-view"> {{profileData?.countryCode}}{{profileData?.mobileNumber}}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="text-center mt40 mb40">
                    <button class="btn btn-large  max-WT-150 btn-theme" (click)="changePassword()">Change
                        Password</button>
                    <button class="btn btn-large  max-WT-150 btn-theme" (click)="editApi()">Edit</button>
                </div>
            </div>
        </div>
        }

        <!-- Edit profile screen start here   -->
        @if(editProfileStatus){
        <div class="content-section">
            <div class="order-view  max-WT-700 mrgn-0-auto setting-page">
                <form [formGroup]="form">
                    <div class="admin-profile">
                        <h4 class="mb20 text-center">Edit Profile</h4>
                    </div>
                    <div class="add-store-block input-style view-label-align">
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12" style="text-align: center">
                                <img src="{{imageUrl || 'assets/img/profile-img.jpg' }}"
                                    style="height: 100px;width: 100px; border-radius: 50%" (error)="onImageError($event)" />
                                <br>
                                <span class="camera">
                                    <i class="fa fa-camera" style="display:flex; ">
                                        <input type="file" class="cameraInput" accept="image/jpg,image/jpeg,image/png"
                                            id="file" (change)="ValidateFileUpload($event)">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row mt-3 align-items-baseline">
                            <label class="col-md-4 textalignright ">
                                <h6>First Name :</h6>
                            </label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group">
                                    <input type="text" name="" id="" formControlName="firstName"
                                        (keypress)="mainService.allowOnlyAlphabets($event)" placeholder="Name"
                                        class="form-control">
                                    @if(form.get('firstName')?.hasError('pattern')&&
                                    form.get('firstName')?.dirty){
                                    <span>
                                        <small class="text-danger">*Please enter valid First Name.</small>
                                    </span>
                                    }
                                    @if(form.get('firstName')?.hasError('required')&& form.get('firstName')?.dirty){
                                    <span>
                                        <small class="text-danger">*First Name is required.</small>
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="form-group row mt-3 align-items-center">
                            <label class="col-md-4">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" placeholder="Last name"
                                    formControlName="lastName" maxlength="256"
                                    (keypress)="mainService.allowOnlyAlphabets($event)" minlength="2">
                            </div>
                        </div>

                        <div class="form-group row mt-3 align-items-baseline">
                            <label class="col-md-4 textalignright">
                                <h6>Email : </h6>
                            </label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group ">
                                    <input type="text" name="" disabled id="" formControlName="email"
                                        placeholder="Email" class="form-control">
                                    @if(form.get('email')?.hasError('pattern')&& form.get('email')?.dirty){
                                    <span>
                                        <small class="text-danger">*Please enter valid email.</small>
                                    </span>
                                    }
                                    @if(form.get('email')?.hasError('required')&& form.get('email')?.dirty){
                                    <span>
                                        <small class="text-danger">*Email is required.</small>
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="form-group row mt-3 align-items-baseline">
                            <label class="col-md-4 textalignright">
                                <h6>Phone Number : </h6>
                            </label>
                            <div class="col-md-3">
                                <select name="patient" style="padding: 0 30px" formControlName="phone_code"
                                    class="custom-select form-control" id="inputGroupSelect01"
                                    aria-labelledby="dropdownMenuButton">
                                    @for (data of countryArr; track data; let i = $index) {
                                    <option [value]="data.phone_code || profileData?.countryCode">
                                        {{data.phone_code}} &nbsp; {{data.name}}
                                    </option>
                                    }
                                </select>
                            </div>
                            <div class="col-md-5 textaligncenter">
                                <div class="form-group ">
                                    <input type="text" name="" id="" formControlName="phoneNumber"
                                        placeholder="phone number" class="form-control">
                                    @if(form.get('phoneNumber')?.hasError('pattern')&&
                                    form.get('phoneNumber')?.dirty){
                                    <span>
                                        <small class="text-danger">*Please enter valid Phone Number.</small>
                                    </span>
                                    }
                                    @if(form.get('phoneNumber')?.hasError('required')&&
                                    form.get('phoneNumber')?.dirty){
                                    <span>
                                        <small class="text-danger">*Phone Number is required.</small>
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="text-center mt-3 mb-3">
                        <button class="btn btn-large  max-WT-150 btn-theme" [disabled]="form.invalid"
                            (click)="updateApi()">Update</button>
                        <button class="btn btn-large  max-WT-150 btn-danger ms-3" (click)="back()">Cancel </button>
                    </div>
                </form>

            </div>
        </div>
        }

    </main>
</div>